module.exports = __webpack_public_path__ + "static/media/h4.044ae1dd.mp4";